import { attendeeFetchData, attendeeSendData } from "./index";

const scanAPI = {
  scan: (attendeeId, token) => attendeeSendData(
    `/api/v2/attendees/${attendeeId}/scan`,
    { token },
    { headers: { 'Content-Type': 'application/json' } }
  ),
  active: (attendeeId) => attendeeFetchData(`/api/v2/attendees/${attendeeId}/scan/active`),
  today: (attendeeId) => attendeeFetchData(`/api/v2/attendees/${attendeeId}/scan/today`),
}

export default scanAPI
